import React from "react";

const CarnetIcon = () => {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.625 9.75C12.625 8.49337 11.6316 7.5 10.375 7.5C9.11837 7.5 8.125 8.49337 8.125 9.75C8.125 11.0066 9.11837 12 10.375 12C11.6316 12 12.625 11.0066 12.625 9.75Z"
        fill="#30323A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.25 4.125C0.25 2.27437 1.77437 0.75 3.625 0.75H28.375C30.2256 0.75 31.75 2.27437 31.75 4.125V19.875C31.75 21.7256 30.2256 23.25 28.375 23.25H3.625C1.77437 23.25 0.25 21.7256 0.25 19.875V4.125ZM5.875 9.75C5.875 7.275 7.9 5.25 10.375 5.25C12.85 5.25 14.875 7.275 14.875 9.75C14.875 11.0033 14.3384 12.1316 13.5036 12.9495C14.2694 13.4662 14.8972 14.1624 15.3323 14.9773C15.7674 15.7922 15.9966 16.7012 16 17.625H13.75C13.75 15.7485 12.2515 14.25 10.375 14.25C8.4985 14.25 7 15.7485 7 17.625H4.75C4.75338 16.7012 4.98262 15.7922 5.41772 14.9773C5.85283 14.1624 6.48061 13.4662 7.24638 12.9495C6.41162 12.1316 5.875 11.0021 5.875 9.75ZM27.25 8.625H18.25V6.375H27.25V8.625ZM27.25 13.125H18.25V10.875H27.25V13.125ZM18.25 17.625V15.375H23.875V17.625H18.25Z"
        fill="#30323A"
      />
    </svg>
  );
};

export default CarnetIcon;
